<h1 mat-dialog-title>Select which crops you want to download for your {{ imageAmount }} image(s)</h1>
<button mat-raised-button class="toggle-button" color="primary" (click)="selectCrops()">Check/uncheck all</button>
<mat-dialog-content>
  <div class="margin-rows">
    <table mat-table *ngIf="cropData && cropData.length > 0" [dataSource]="cropData" class="striped ts-table">

      <!-- Title Column -->
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let crop" (click)="selectCrop(crop)"> {{ crop.description }} </td>
      </ng-container>
  
      <!-- Subtitle Column -->
      <ng-container matColumnDef="Path">
        <th mat-header-cell *matHeaderCellDef> Path </th>
        <td mat-cell *matCellDef="let crop" (click)="selectCrop(crop)"> {{ crop.path }} </td>
      </ng-container>
  
      <!-- Cost EUR Column -->
      <ng-container matColumnDef="Size">
        <th mat-header-cell *matHeaderCellDef> Size </th>
        <td mat-cell *matCellDef="let crop" (click)="selectCrop(crop)"> 
          <span *ngIf="crop.description !== 'Source'">
            {{ crop.width }} x {{ crop.height || roundNumber(crop.width, crop.ratio, selectedImages[0]) }}
          </span>
          <span *ngIf="crop.description === 'Source'">
            Uploaded image
          </span>
        </td>
      </ng-container>
  
      <!-- Actions Column -->
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell class="crop-checkbox" *matCellDef="let crop">
          <mat-checkbox [checked]="checkSelectedCrops(crop) === true" (change)="selectCrop(crop)"></mat-checkbox>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="error" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="closeDialog()" [disabled]="selectedIds.length === 0">Confirm</button>
</mat-dialog-actions>

<div *ngIf="busy === true" class="transparent">
  <img src="/assets/img/logo-preloader.png" alt="..." class="logo-loading animate-flicker" />
</div>